import { FilterList } from '@mui/icons-material';
import { translateKey } from 'src/locales/translate';
import { Button, Skeleton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import { TemplatesAddNewButton } from './TemplatesAddNewButton';
import TemplatesFiltersForm from './TemplatesFiltersForm';
import TemplatesTable from './TemplatesTable';

export const TemplatesContent = () => {
  const isLoading = false;
  const [filtersOpen, setFiltersOpen] = useState(false);

  return !isLoading ? (
    <>
      <Stack
        sx={{
          p: 3,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6">Szablony notatek</Typography>
        <Stack direction="row" spacing={1}>
          <Button
            size="medium"
            variant="outlined"
            startIcon={<FilterList />}
            onClick={() => setFiltersOpen(!filtersOpen)}
            color={filtersOpen ? 'primary' : 'inherit'}
          >
            {translateKey('visit.historyFiltersTooltip')}
          </Button>
          <TemplatesAddNewButton />
        </Stack>
      </Stack>
      <TemplatesFiltersForm isOpen={filtersOpen} />
      <TemplatesTable />
    </>
  ) : (
    <Stack sx={{ minHeight: '560px', height: 1 }}>
      <Stack p={3}>
        <Skeleton variant="rounded" height="28px" width="260px" />
      </Stack>
      {/* <VisitHistoryTableSkeleton /> */}
    </Stack>
  );
};
